(function() { window.GUID_25c6b9de_7857_4a52_a6a4_43051cd5a6ff = { getGuid: function() { return "25c6b9de-7857-4a52-a6a4-43051cd5a6ff"; } }; })();
var MasterSearchKeyCodeAnalyser;
(function (MasterSearchKeyCodeAnalyser) {
    var desktop;
    (function (desktop) {
        function GetScoreSheetCodeInMasterSearch() {
            var searchCode = MasterPage.TxtMasterSearch.val();
            if (searchCode.length >= 3) {
                var firstChar = searchCode.substr(0, 1);
                var secondChar = searchCode.substr(1, 1);
                var thirdChar = searchCode.substr(2, 3);
                /*les keycodes peuvent avoir jusqu'a 3 lettres.*/
                if (searchCode.length >= 4) {
                    var thirdCharv2 = searchCode.substr(2, 1);
                    if (thirdCharv2 != parseInt(thirdCharv2, 10)) /*si le 3e char n'est pas un chiffre*/ {
                        secondChar = secondChar + thirdCharv2;
                        thirdChar = searchCode.substr(3, 3);
                    }
                }
                var thirdIntValue = parseInt(thirdChar, 10);
                if (isNaN(firstChar) && isNaN(secondChar) && !isNaN(thirdIntValue)) {
                    MasterPage.TxtMasterSearch.val("");
                    var data = {
                        keyCode: firstChar + secondChar,
                        encounterNumber: thirdChar,
                        elementToRefresh: ""
                    };
                    return data;
                }
            }
            return null;
        }
        desktop.GetScoreSheetCodeInMasterSearch = GetScoreSheetCodeInMasterSearch;
        function GetExtMatchInMasterSearch() {
            var searchCode = MasterPage.TxtMasterSearch.val();
            if (searchCode.length > 0) {
                if (searchCode.indexOf(' ') == -1) {
                    var num = parseInt(searchCode, 10);
                    if (!isNaN(num)) {
                        return num;
                    }
                }
            }
            return null;
        }
        desktop.GetExtMatchInMasterSearch = GetExtMatchInMasterSearch;
    })(desktop = MasterSearchKeyCodeAnalyser.desktop || (MasterSearchKeyCodeAnalyser.desktop = {}));
})(MasterSearchKeyCodeAnalyser || (MasterSearchKeyCodeAnalyser = {}));

//# sourceMappingURL=MasterSearchKeyCodeAnalyser.desktop.js.map
